export default {
  nav: {
    module: "Modules",
    moduleUser: "Gebruiker instellingen",
    settingsModule: "Module instellingen",
    settingsClient: "Systeem instellingen",
  },

  userModules: {
    myAccount: "Mijn gegevens",
  },

  intro: {
    settings: {
      title: "Settings",
      text: "Gebruikt het menu aan de linker kant, meer zal volgen",
    },
    module: {
      title: "Modules",
      text: "Gebruikt het menu aan de linker kant, meer zal volgen",
    },
  },
}
